import React from 'react';
import PropTypes from 'prop-types';
import { Table, Badge } from 'react-bootstrap';
import moment from 'moment';
import SectorTableRow from './SectorTableRow';

function SectorTable({
  measurables,
  timesAgo,
  calculateColName,
  capitalizeFirstLetter,
  sheduleTypeText,
  selectedCurrentMonth,
  selectedSubOneMonth,
  idEditing,
  setIdEditing,
  handleSaveUserIncharge,
  toggleMesurabledModal,
  setMesurableData,
  toggleTargetSettingdModal,
  setTargetSettingData,
  sheduleTypeId,
  getMeasurables,
  noOfCol,
  isDark
}) {
  return (
    <Table
      responsive
      borderless={true}
      style={{
        backgroundColor: !isDark ? '#edf2f9' : '#0B1727',
        borderRadius: '10px'
      }}
    >
      <thead>
        <tr>
          <th className="text-center" style={{ width: '5vw' }}>
            #
          </th>
          <th style={{ width: '20vw' }}>Measurable</th>
          <th className="text-center" style={{ width: '15vw' }}>
            Target {moment(selectedSubOneMonth).format('MMM-YY')}
          </th>
          <th className="text-center" style={{ width: '15vw' }}>
            Target {moment(selectedCurrentMonth).format('MMM-YY')}
          </th>
          <th
            className="text-center"
            style={{ width: idEditing > 0 ? '15vw' : '5vw' }}
          >
            #
          </th>
          <th className="text-center" style={{ width: '10vw' }}>
            Variation Percentage
          </th>

          {timesAgo.map((time, index) => (
            <th key={index} className="text-center" style={{ width: '15vw' }}>
              <Badge style={{ fontSize: '12px' }}>
                {calculateColName(time.date)}
              </Badge>
              <br />
              {capitalizeFirstLetter(sheduleTypeText)} -{time.index}
            </th>
          ))}
        </tr>
      </thead>

      <tbody>
        {measurables.map((item, index) => (
          <SectorTableRow
            key={index}
            index={index}
            item={item}
            timesAgo={timesAgo}
            idEditing={idEditing}
            setIdEditing={setIdEditing}
            handleSaveUserIncharge={handleSaveUserIncharge}
            toggleMesurabledModal={toggleMesurabledModal}
            setMesurableData={setMesurableData}
            toggleTargetSettingdModal={toggleTargetSettingdModal}
            setTargetSettingData={setTargetSettingData}
            selectedCurrentMonth={selectedCurrentMonth}
            selectedSubOneMonth={selectedSubOneMonth}
            sheduleTypeId={sheduleTypeId}
            measurables={measurables}
            getMeasurables={getMeasurables}
            noOfCol={noOfCol}
          />
        ))}
      </tbody>
    </Table>
  );
}

SectorTable.propTypes = {
  measurables: PropTypes.array,
  timesAgo: PropTypes.array,
  calculateColName: PropTypes.func,
  capitalizeFirstLetter: PropTypes.func,
  sheduleTypeText: PropTypes.string,
  selectedCurrentMonth: PropTypes.instanceOf(Date),
  selectedSubOneMonth: PropTypes.instanceOf(Date),
  idEditing: PropTypes.number,
  setIdEditing: PropTypes.func,
  handleSaveUserIncharge: PropTypes.func,
  toggleMesurabledModal: PropTypes.func,
  setMesurableData: PropTypes.func,
  toggleTargetSettingdModal: PropTypes.func,
  setTargetSettingData: PropTypes.func,
  sheduleTypeId: PropTypes.number,
  getMeasurables: PropTypes.func,
  noOfCol: PropTypes.number,
  isDark: PropTypes.bool
};

export default SectorTable;
